module.exports = __webpack_public_path__ + "static/media/icn-compare.1e961a8e.svg";